import React from 'react';
import { Box, Typography } from '@mui/material';
import { INSUFFICIENT_PERMISSION_MESSAGE } from '../permissions/constants';

export default function InsufficientPermissionPage() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        textAlign: 'center',
        px: 3,
      }}
    >
      <Typography variant="h1" gutterBottom>
        Insufficient permissions
      </Typography>
      <Typography color="text.secondary">{INSUFFICIENT_PERMISSION_MESSAGE}</Typography>
    </Box>
  );
}
